export default __webpack_public_path__ + "a63bad82dfa70fa9420b426068242c14.svg";